// LogoV3 — Global Lead Suite wordmark with electric-blue G-mark.
import React from "react";
import { Link } from "react-router-dom";

export default function LogoV3({ testId = "header-v3-logo" }) {
    return (
        <Link
            to="/v3"
            className="flex items-center gap-2.5 no-underline group"
            data-testid={testId}
            aria-label="Global Lead Suite home"
        >
            <div
                className="w-9 h-9 rounded-xl flex items-center justify-center text-white font-bold text-lg shrink-0 shadow-[0_4px_16px_rgba(255, 255, 255,0.35)] group-hover:shadow-[0_6px_22px_rgba(255, 255, 255,0.5)] transition-shadow"
                style={{ background: "linear-gradient(135deg, #FFFFFF 0%, #CCCCCC 100%)" }}
                aria-hidden
            >
                G
            </div>
            <span className="text-white font-semibold text-base sm:text-lg tracking-tight whitespace-nowrap">
                Global Lead Suite
            </span>
        </Link>
    );
}
